module.exports = __webpack_public_path__ + "img/concise.7d495d3d.svg";